// fetch client deposits
export const FETCH_CLIENT_DEPOSITS_REQUESTED = 'FETCH_CLIENT_DEPOSITS_REQUESTED'
export const FETCH_CLIENT_DEPOSITS_SUCCESS = 'FETCH_CLIENT_DEPOSITS_SUCCESS'
export const FETCH_CLIENT_DEPOSITS_FAIL = 'FETCH_CLIENT_DEPOSITS_FAIL'
